export const mainCn = {
    sousuo:"检索",
    placeholder:"请输入关键字",
    fuwuliucheng:"服务流程",
    fuwushenqing:"服务申请",
    huoqubaojia:"获取报价",
    hetongqianding:"合同签订",
    chanpingjiance:"产品检测",
    zaixianfazheng:"在线发证",
    diquguojia:"地区国家",
    ziliaowenku:"请选择信息类型",
    ziliaowenk:"资料文库",
    xinxileixing:"信息类型",
    qzxcprz:"强制性产品认证",
    faburiqi:"发布日期",
    xuanzeriqi:"选择日期",
    jcrzsjzx:"检测认证数据中心",
    rzjgzhcx:"认证结果综合查询",
    zssy:"证书溯源",
    jcjgxx:"检测机构信息",
    rzgzcx:"认证规则查询",
    rzbzcx:"认证标准查询",
    cyzgcx:"证书编号：",
    zsbh:"证书编号",
    hzzzmc:"证书名称：",
    rzxm:"认证项目：",
    qingxuanze:"请选择",
    zszt:"证书状态：",
    zszt1:"证书状态",
    rkzt:"认可标识：",
    pxfu:"培训服务",
    bofangpaihang:"播放排行",
    zhuanjiazixun:"专家咨询",
    hezuojigou:"合作机构",
    jiancerenzxgj:"检测认证小工具",
    hzzzbh:'获证组织名称：',
    qsrzsbh:'请输入证书编号',
    qsrzsmc:'请输入证书名称',
    dingdbh:'订单编号',
    sangpmc:'商品名称',
    cjzxm:'创建者姓名',
    guojiabiaozunchaxun:'国家标准查询',
    shipingshujukuchaxun:"食品数据库查询",
    shengqingqiyeztmc:'申请企业主体名称'
}


// WEBPACK FOOTER //
// ./src/lang/home/main/mainCn.js